import type { ReactNode } from "react";
import { Modal } from "./Modal";

export interface MessageModalProps {
  open: boolean;
  onClose: () => void;
  title: string;
  children: ReactNode;
  okLabel?: string;
}

/**
 * Single-action dialog for validation summaries, success toasts that
 * need acknowledgement, etc. Uses the same visual language as
 * {@link Modal} / {@link ConfirmModal}.
 */
export function MessageModal({
  open,
  onClose,
  title,
  children,
  okLabel = "OK",
}: MessageModalProps) {
  return (
    <Modal
      open={open}
      onClose={onClose}
      title={title}
      footer={
        <button
          type="button"
          className="btn btn-primary"
          onClick={onClose}
          autoFocus
        >
          {okLabel}
        </button>
      }
    >
      <div
        style={{
          fontSize: "0.95rem",
          lineHeight: 1.55,
          color: "var(--portal-text)",
          whiteSpace: "pre-wrap",
        }}
      >
        {children}
      </div>
    </Modal>
  );
}
